
<template>
<!-- Remember to include jQuery :) -->

  <div class="hello">
  <div style="text-align:right; padding-right:8px;">
    <my-room-navigator />
    <select v-model="filter"  style="margin-left:5px; border-radius:4px; padding:4px 5px; background:#fff; font-size:12px;">
      <option value="">ALL</option>
      <option value="hair" >헤어</option>
      <option value="clothes" >옷</option>
      <option value="weapon" >액세서리</option>
      <option value="shoes">신발</option>
      <option value="face" >표정</option>
      <option value="pet" >펫</option>
    </select>
  </div>

        <div class="tab-content">
                <!-- <router-view/> -->
                <div>

                    <div class="item_box" v-for="item in items" style="height:224px;">
                      <div class="item_box_title">{{ item.name }} <span v-if="item.status == 0"
                            style="background:#007bff; color:#fff; font-size:11px; padding:1px 3px; border-radius:4px;">NEW</span></div>
                      <span style="color:#42f8ff; font-size:11px;line-height:12px;">{{ $parent.loginID == item.sender ? "보낸 선물" : "받은 선물"}}</span>
                      <div class="item_box_item"  style="position:relative;"><img :src="'https://avatar.useschool.co.kr/avatar/img/item/' + item.type + '/' + item.code + '.png'">
                                              <div style="position:absolute; left:3px; top:3px;"><span
                                style=" color:#333; font-size:10px; font-weight:bold; padding:0px 4px; border-radius:4px;"
                                v-bind:style="{backgroundColor: item.tier == 'EVENT' ? '#55ff19' : '#FFB400'}">{{ item.tier }}</span>
                        </div>
                        </div>
                      <div class="item_box_price_fame" style="font-size:12px;color:#fff;">
                          {{ item.target }} <br>

                        </div>
                      <!--div class="item_box_buy_fame btn-danger" v-if="$parent.loginID == item.sender" @click="cancel(item.id, true)">취소</div-->
                      <div class="item_box_buy_fame btn-primary" data-toggle="modal" data-target="#exampleModal" v-on:click="openItemDialog(item);">확인</div>



                    <!-- <div style="text-align: center; color: #fff; font-size: 14px; margin-top: 20px;">◀ 1 / 2 ▶</div> -->

                </div>
                <br>
					<div style="clear:both">&nbsp;</div>
                <div style="text-align:center; position:relative; top:00px; ">
                <router-link :to="'./' + (+currentPage - 1)" v-if="currentPage > 1"><span style="font-size: 12px; padding:2px 4px;" class="btn btn-danger">◀&nbsp;PREV</span></router-link>&nbsp;
                <router-link :to="'./' + (+currentPage + 1)" v-if="items.length >= 8"><span style="font-size: 12px; padding:2px 4px;" class="btn btn-primary">▶&nbsp;NEXT </span></router-link>
				</div>
              </div>
  </div>


<!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document" >
    <div class="modal-content" style="background:#202020; color:#bcbcbc;">
      <div class="modal-header" style="border-bottom:1px solid #333; margin:10px 16px;">
        <h5 class="modal-title" id="exampleModalLabel">아이템 받기</h5>
        <button type="button" class="close" style="color:#fff;" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
	  <div style=text-align:center;>
	   <div style="border-radius: 10px; display:inline-block; padding:2px 14px;  text-align: center; font-size:18px; background:#ffb400; font-weight:bold;color:#333; margin-bottom:20px;  letter-spacing: -1.4px;">{{ modalDesc.item.name }}</div>
	   <div style="text-align:center;"><img :src="'//avatar.useschool.co.kr/avatar/img/item/' + modalDesc.item.type + '/' + modalDesc.item.code + '.png'" ></div>
        </div>


	<div style="font-size: 14px; font-weight: normal; color: #fff; line-height: 16px;">{{ modalDesc.item.description }}<br><br>
		<span style="color: #00f6ff; font-weight: 600;">{{ modalDesc.item.skill }}</span>
</div>


    <div style="height:1px; background:#333333; margin-top: 8px;"></div>
  <div style="height:1px; background:#111; margin-bottom: 8px;"></div>
  <strong style="color:#fff;">선물 메시지</strong><br>
          <span style="font-size:14px;"> "{{ modalDesc.item.req_message }}" </span><br>
    <div style="height:1px; background:#333333; margin-top: 8px;"></div>
  <div style="height:1px; background:#111; margin-bottom: 8px;"></div>
  <!-- 안 받은 incoming 이라면 버튼과 셀렉박스
       받은 incoming 혹은 outgoing이라면 그냥 텍스트만 -->
    <template v-if="modalDesc.item.status == 0 && direction == 'incoming'">
      <button class="btn btn-secondary" style="margin-right:10px;" :class="{'active': modalDesc.action == 'accept'}" @click="modalDesc.action='accept'">감사 메시지</button>
      <button class="btn btn-dark" :class="{'active': modalDesc.action == 'reject'}" @click="modalDesc.action='reject'">거절 메시지</button>
      <select class="form-control" v-model="modalDesc.item.resp_message" v-if="modalDesc.action">
          <option value="" selected>친구에게 보내는 메시지를 선택해 주세요</option>
          <option v-for="msg in (modalDesc.action == 'accept' ? acceptMsgs : rejectMsgs)" :key="msg" :value="msg">{{msg}}</option>
      </select>
    </template>
    <template v-else-if="modalDesc.item.resp_message">
        <strong style="color:#fff;"><template v-if="modalDesc.item.status == 1">감사</template><template v-if="modalDesc.item.status == 2">거절</template> 메시지</strong><br>
  "{{ modalDesc.item.resp_message }}"<br>
    </template>

        <div style="padding-top:10px;">
            <span style="font-size:13px;">※ 이용안내</span><br>
        <span style="font-size:13px;">- 받은 아이템은 <span style="color:#ffcc00;">{{ modalDesc.item.period }}</span> 사용 가능 합니다.</span><br>
		<template v-if="direction == 'incoming'">
            <span style="font-size:13px;">- 친구에게 감사 또는 거절 메시지를 선택 후 보낼 수 있습니다.</span><br>
        </template>
        <template v-if="direction == 'outgoing'">
             <span style="font-size:13px;">- 친구에게 보낸 선물 취소하기는 상대방이 감사 또는 거절 메시지를 보내기 전까지 가능합니다.<br>
                - 취소 완료시 사용된 Carat 점수는 다시 적립됩니다.</span> <br>
        </template>
          </div>
      </div>
      <div class="modal-footer" style="border-top:1px solid #333;">
        <button type="button" class="btn btn-primary" :data-dismiss="modalDesc.item.resp_message ? 'modal' : ''" @click="buyItem(modalDesc.item.prcId, modalDesc.item.id)" v-if="direction == 'incoming' && modalDesc.item.status ==0 && modalDesc.action == 'accept'">메시지 보내기</button>
        <button type="button" class="btn btn-danger" :data-dismiss="modalDesc.item.resp_message ? 'modal' : ''" @click="cancel(modalDesc.item.id, false)" v-if="modalDesc.item.status ==0 && (modalDesc.action == 'reject' || direction == 'outgoing')">
          <template v-if="direction == 'incoming'">메시지 보내기</template>
          <template v-if="direction == 'outgoing'">취소하기</template>
          </button>
        <button type="button" class="btn btn-light" data-dismiss="modal">닫기</button>
      </div>
    </div>
  </div>
</div>

  </div>

</template>

<script>
import axios from 'axios';
import MyRoomNavigator from '../components/MyRoomNavigator.vue';
export default {
  components: { MyRoomNavigator },
  name: 'home',
  props: {
    direction: String
  },
  methods: {
    fetchData(page) {
      this.currentPage = page;
        axios.get(this.$parent.persistent.apiUrl + 'giftBox.php?page=' + page + '&uid=' + this.$parent.loginID + '&direction=' + this.direction + (this.filter ? '&filtertype=' + this.filter : ''))
        .then(response => {
            // console.log(response.data)
            this.items = response.data.items
        }).catch((error) => console.log(error));
    },
        openItemDialog(item){

      this.modalDesc.item = item;
      this.modalDesc.item.resp_message = ""
    },
    buyItem(prcId, giftId){
        axios.get(this.$parent.persistent.apiUrl + 'buyItem.php?priceId=' + prcId + '&uid=' + this.$parent.loginID + "&useGiftPay=" + giftId + "&resp_message=" + this.modalDesc.item.resp_message)
        .then(response => {
            // console.log(response.data)
            // this.items = response.data.items
            if(!this.modalDesc.item.resp_message){
              this.$parent.alert("친구에게 보내는 메시지를 선택해 주세요.");
              return;
            }
            if(response.data.status == "error"){
              this.$parent.alert(response.data.reason)
            } else {
              this.$parent.alert("받기 성공")
              this.$parent.fetchMyInfo()
              this.fetchData(this.currentPage)
            }
        }).catch((error) => console.log(error));
    },
    cancel(id, senderCancel){
      if(this.direction == "incoming" && !this.modalDesc.item.resp_message){
              this.$parent.alert("친구에게 보내는 메시지를 선택해 주세요.");
              return;
      }
    axios.get(this.$parent.persistent.apiUrl + 'cancelGift.php?id=' + id + '&uid=' + this.$parent.loginID + (this.direction == "outgoing" ? "&senderCancel=true" : "&resp_message=" + this.modalDesc.item.resp_message))
        .then(response => {
            // console.log(response.data)
            // this.items = response.data.items
            this.$parent.alert(response.data.reason)
            if(response.data.status != "error"){
              this.$parent.fetchMyInfo()
              this.fetchData(this.currentPage)
            }
        }).catch((error) => console.log(error));
    }
},
  mounted(){

  },
    watch: {
    '$route.params': {
        handler(newValue) {
            const { page } = newValue

            this.fetchData(page)
        },
        immediate: true,
    },
        'filter': {
      handler(){
        this.fetchData(1)
      }
    }
},

data(){
  return {
    items: [],
    modalDesc: {
      item: {},
      buyPrice: "",
      action: "accept"
    },
    alertModal: "",
    currentPage: 1,
    acceptMsgs: [
"정말 고마워요! 감동이에요~",
"WOW! 저도 조만간 선물로 보답할게요",
"내 아바타랑 잘 어울리는 아이템이야 Thank you~"

    ],
    rejectMsgs: [
"Sorry~ 이미 가지고 있는 있는 아이템이에요",
"감사하지만 마음만 받을게요♡",
"나보다는 다른 친구가 더 어울릴 것 같아"

    ],
    filter: ""
  }
}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
